import { PageTitle } from 'src/components/PageTitle';
import { BrandsDataTable } from 'src/features/branding/feature-branding-list';

import { Icon } from 'src/components/Icon';
import { Button } from 'src/components/Button';
import { Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { links } from 'src/router/routes';

export const Brandings = () => {
  const navigate = useNavigate();

  return (
    <div>
      <PageTitle title="My Brands" />
      <BrandsDataTable />

      <Group justify="flex-end" align="center" mt="xl">
        <Button
          variant="filled"
          size="md"
          round={true}
          icon={<Icon name="add" />}
          onClick={() => navigate(links.brandingNew)}
        >
          ADD NEW
        </Button>
      </Group>
    </div>
  );
};
